module.exports = __webpack_public_path__ + "1660eb4c11b25407f33e7ccb32c2144b.png";